define('directives/myservices/serviceMark/serviceMarkPage.directives',['app','mainCons'], function (app, mainCons) {
    app.directive('serviceMarkPage', ['OpenApp','OpenOther','UserInfo','$filter','$state','$stateParams','OpenFeedBack',function (OpenApp,OpenOther,UserInfo,$filter,$state,$stateParams,OpenFeedBack) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            scope:{
                cloudFileItem:"="
            },
            templateUrl: 'directives/myservices/serviceMark/serviceMarkPage.template.html',
            link: function ($scope, $element, attrs,ngModelCtrl) {

                var serviceItem = $stateParams.serviceItem?$stateParams.serviceItem:$scope.cloudFileItem;
                $scope.manyiCount = 0;
                $scope.chapingCount = 0;
                initPageScore();
                function initPageScore(){
                    var params = {
                        req: {
                            score:[1,0],
                            objectID: serviceItem,
                            objectType:2
                        }
                    };
                    OpenFeedBack.getSumByScore(params).then(function(res){
                        if(res && res.retCode==0){
                            $scope.manyiCount = res.sum[0];
                            $scope.chapingCount = res.sum[1];
                        }else{
                            $scope.manyiCount = 0;
                            $scope.chapingCount = 0;
                        }
                    }).catch(function(res){
                        $scope.manyiCount = 0;
                        $scope.chapingCount = 0;
                    });
                }

            }
        }
    }]);
});
